import { getStatusFromApiError } from './getStatusFromApiError';
export const checkIsClientRelatedError = (error) => {
    const status = getStatusFromApiError(error);
    // If no status it was network issue
    if (!status)
        return false;
    // 5xx status codes are responsibility of BE developers
    if (status < 500)
        return true;
    return false;
};
